import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import { CategoriesProvider } from './context/CategoriesContext';
import { TagsProvider } from './context/TagsContext';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { CatalogPage } from './pages/CatalogPage';
import { ProductPage } from './pages/ProductPage';
import { RetailStorePage } from './pages/RetailStorePage';
import { DeliveryPage } from './pages/DeliveryPage';
import { FoodPrintingPage } from './pages/FoodPrintingPage';
import { StudioPage } from './pages/StudioPage';
import { NotFoundPage } from './pages/NotFoundPage';

function App() {
  return (
    <BrowserRouter>
      <CategoriesProvider>
        <TagsProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="catalog" element={<CatalogPage />} />
              <Route path="catalog/new" element={<Navigate to="/catalog?sort=new" replace />} />
              <Route path="product/:id" element={<ProductPage />} />
              <Route path="retail-store" element={<RetailStorePage />} />
              <Route path="delivery" element={<DeliveryPage />} />
              <Route path="food-printing" element={<FoodPrintingPage />} />
              <Route path="studio" element={<StudioPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </TagsProvider>
      </CategoriesProvider>
    </BrowserRouter>
  );
}

export default App;
